__turbopack_context__.v({
  "button": "ScrollToTopButton-module-scss-module__NUgPDW__button",
  "visible": "ScrollToTopButton-module-scss-module__NUgPDW__visible",
});
